import View from "./notifications.view";
import Presenter from "./notifications.presenter";
import { ConnectComponent2 } from "util";

export default ConnectComponent2(View, Presenter);



// WEBPACK FOOTER //
// ./src/components/support/notifications/index.js